export const toolItems = [
  {
    id: 1,
    name: 'Milwaukee M18 Impact Wrench',
    category: 'Power Tools',
    description: 'The one I reach for every single time. Torque that actually means something.',
    rating: 5,
    affiliateUrl: '#',
    imageUrl: 'https://public.readdy.ai/ai/img_res/e92a2d77f43aa23c60b450ca134ef419.jpg',
  },
  {
    id: 2,
    name: 'Snap-on 3/8" Drive Socket Set',
    category: 'Hand Tools',
    description: '50 pieces. Fits everything. Worth every penny you spend on it.',
    rating: 5,
    affiliateUrl: '#',
    imageUrl: 'https://readdy.ai/api/search-image?query=snap-on%20chrome%20socket%20set%20organized%20in%20red%20metal%20case%20on%20dark%20workshop%20surface%20professional%20product%20photography%20dramatic%20lighting%20high%20contrast&width=300&height=300&seq=tool-socket-baw-2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Fluke 117 Multimeter',
    category: 'Diagnostics',
    description: 'Stop guessing. Know what\'s wrong before you pull anything apart.',
    rating: 5,
    affiliateUrl: '#',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fluke%20yellow%20digital%20multimeter%20with%20probe%20leads%20on%20dark%20metal%20workshop%20surface%20electrical%20diagnostic%20tool%20professional%20product%20photography%20dramatic%20shadows&width=300&height=300&seq=tool-multimeter-baw-3&orientation=squarish',
  },
  {
    id: 4,
    name: 'GearWrench 3/4" Torque Wrench',
    category: 'Hand Tools',
    description: 'Torque specs exist for a reason. Don\'t guess on anything structural.',
    rating: 4,
    affiliateUrl: '#',
    imageUrl: 'https://readdy.ai/api/search-image?query=chrome%20torque%20wrench%20professional%20hand%20tool%20on%20dark%20workshop%20bench%20with%20bokeh%20background%20product%20photography%20warm%20industrial%20lighting%20minimal%20composition&width=300&height=300&seq=tool-torque-baw-4&orientation=squarish',
  },
  {
    id: 5,
    name: 'OTC 3697 Deluxe Puller Set',
    category: 'Specialty',
    description: 'For everything that\'s been stuck since 1987. The unsung hero.',
    rating: 5,
    affiliateUrl: '#',
    imageUrl: 'https://readdy.ai/api/search-image?query=gear%20puller%20set%20specialty%20automotive%20tool%20with%20chrome%20finish%20on%20dark%20garage%20workshop%20surface%20dramatic%20low%20angle%20product%20photography%20strong%20shadows&width=300&height=300&seq=tool-puller-baw-5&orientation=squarish',
  },
  {
    id: 6,
    name: 'Klein Tools Wire Stripper',
    category: 'Electrical',
    description: 'Every electrical job. Without fail. Just have one.',
    rating: 4,
    affiliateUrl: '#',
    imageUrl: 'https://readdy.ai/api/search-image?query=Klein%20Tools%20red%20wire%20stripper%20electrical%20hand%20tool%20on%20dark%20metal%20workshop%20bench%20professional%20product%20photography%20clean%20minimal%20background%20warm%20studio%20lighting&width=300&height=300&seq=tool-stripper-baw-6&orientation=squarish',
  },
];
